<template>
  <div class="page">
    <div class="content">
      <div class="title">
        <div class="name">确认订单</div>
      </div>
      <div class="address">
        <div class="address_title">收货地址</div>
        <div v-if="showAddress && showAddress.id" class="address-content">
          <div class="phone">
            {{ showAddress.name }} {{ showAddress.phone }}
          </div>
          <div class="address_detail">
            {{ showAddress.areaName }}{{ showAddress.detailAddress }}
          </div>
          <el-button size="large" class="edit" @click="openModal">
            修改
          </el-button>
        </div>
        <div v-else class="no-address">
          <el-button size="large" type="primary" @click="openModal">
            请选择收货地址
          </el-button>
        </div>
      </div>
      <!-- 基础信息 -->
      <div class="base_info">
        <div class="info_title">商品信息</div>
        <div v-for="(item, index) in orderInfo.itemList" :key="index">
          <div class="info_list">
            <div class="left_title">
              {{ item.goodsName }}
            </div>
            <div class="left">
              <div class="left_content_list">
                <div class="pic">
                  <img :src="item.image" alt="" />
                </div>
                <div class="text_list">
                  <div class="price">￥{{ formatPrice(item.price) }}</div>
                  <div class="text_title">
                    红色款【非祖国果冻唇】；盲盒随机发不指定
                  </div>
                  <div class="text_count">数量：{{ item.goodsNumber }}</div>
                  <!-- <div class="count">
                    <div class="left1" @click="handleCount('reduce', 1)">-</div>
                    <div class="mid">{{ 1 }}</div>
                    <div class="right1" @click="handleCount('add', 1)">+</div>
                  </div> -->
                </div>
              </div>
              <div class="mid">
                <div class="mid_title">配送服务</div>
                <div class="mid_content">
                  <div class="item">
                    ￥{{ formatPrice(orderInfo.logisticsPrice) }}
                  </div>
                  <!-- <div class="item">快递</div>
                  <div class="item">免邮</div>
                  <div class="item">送运费险</div> -->
                </div>
                <div class="mid_title">订单备注</div>
                <div class="mid_item">无备注</div>
              </div>
              <!-- <div class="right">
                <div class="right_title">优惠</div>
                <div class="right_item">全场8折</div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="info_title">价格明细</div>
        <div class="info_list">
          <div class="price_detail">
            <div class="detail_list">
              <div class="price_detail_title">商品总价</div>
              <div class="price_detail_price">
                ￥{{ formatPrice(orderInfo.payPrice) }}
              </div>
              <!-- <div class="price_detail_title">优惠</div>
              <div class="price_detail_price">减￥56.00</div> -->
            </div>
            <div class="way_list">
              <div
                v-for="ch in enabledChannels"
                :key="ch.channelCode"
                class="way_item"
              >
                <img
                  v-if="ch.channelCode === 'MOCK'"
                  src="@/assets/images/svg/back.svg"
                  alt=""
                  class="way-icon"
                />
                <img
                  v-else-if="ch.channelCode && ch.channelCode.startsWith('ALI')"
                  src="@/assets/images/zhifubao.png"
                  alt=""
                />
                <img
                  v-else-if="ch.channelCode && ch.channelCode.startsWith('WX')"
                  src="@/assets/images/zhifubao.png"
                  alt=""
                />
                <img v-else src="@/assets/images/zhifubao.png" alt="" />
                <div class="item_title">
                  {{ ch.channelName || ch.channelCode }}
                </div>
              </div>
              <div
                v-if="!enabledChannels.length"
                class="way_item way_item_empty"
              >
                暂无可用的支付方式
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="accounts">
        <template v-if="!createdOrderId">
          <div class="accounts1">共计商品</div>
          <div class="accounts2">{{ selectedAllNum }}</div>
          <div class="accounts3">件</div>
          <div class="accounts4">合计</div>
          <div class="accounts5">￥{{ formatPrice(orderInfo.payPrice) }}</div>
          <div class="submit" @click="account">结算</div>
          <div
            v-if="hasMockChannel"
            class="submit submit-mock"
            @click="accountThenMockPay"
          >
            结算并模拟支付（测试）
          </div>
        </template>
        <template v-else>
          <div class="accounts1">订单已创建</div>
          <div class="accounts2" style="color: #333">请选择支付方式</div>
          <div class="pay-actions">
            <div
              v-if="hasRealChannel"
              class="submit"
              @click="payFor(createdOrderId)"
            >
              去支付
            </div>
            <div
              v-if="hasMockChannel"
              class="submit mock-pay"
              @click="handleMockPay"
            >
              模拟支付（测试）
            </div>
            <div
              v-if="!hasRealChannel && !hasMockChannel"
              class="pay-actions-tip"
            >
              暂无可用的支付方式
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="back" @click="jump('/')">
      <img src="@/assets/images/svg/back.svg" alt="" />
    </div>
  </div>
  <el-dialog v-model="modal">
    <div style="min-height: 300px">
      <Address
        @getSelectAddress="getSelectAddress"
        :selectAddress="showAddress"
      ></Address>
    </div>
    <template #footer>
      <div style="text-align: center">
        <el-button @click="modal = false">取消</el-button>
        <el-button type="primary" @click="handleSureAddress">确 定</el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script setup>
import { ref, onBeforeMount, computed, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useToast } from "vue-toast-notification";
import { getAddressList } from "@/api/address";
import {
  createOrder,
  createOrderDirect,
  pay,
  mockPaymentSuccess,
  getPaymentChannels,
  JSCart,
  JSCartDirect,
} from "@/api/shopping";
import Address from "@/components/addressIndex.vue";
// import { useSureOrderStore } from "@/stores/sureOrder";
const router = useRouter();
const $toast = useToast();
// const sureOrderStore = useSureOrderStore();
const orderInfo = ref({
  itemList: [
    {
      goodsId: 0,
      goodsName: "",
      skuId: 0,
      price: 0,
      image: "",
      cartId: 0,
      goodsNumber: 0,
    },
  ],
  logisticsPrice: 0,
  payPrice: 0,
  recipientName: "",
  recipientPhone: 0,
  areaName: "",
  detailAddress: "",
  defaultAddress: false,
});
/** 来自购物车：info 为 [{ cartId }]；来自立即购买：info 为 { direct: true, items: [{ productId, skuId, quantity }] } */
const info = ref(null);
/** 是否立即购买（不经过购物车） */
const isDirectBuy = ref(false);
/** 创建成功后的订单 ID，用于展示去支付 / 模拟支付 */
const createdOrderId = ref(null);
/** 当前已开启的支付方式（与后台支付管理同步） */
const enabledChannels = ref([]);

onMounted(() => {
  const route = useRoute();
  getPaymentChannels()
    .then((res) => {
      const list = res?.data ?? res;
      enabledChannels.value = Array.isArray(list) ? list : [];
    })
    .catch(() => {
      enabledChannels.value = [];
    });
  try {
    const dataStr = decodeURIComponent(route.params.data);
    const parsed = JSON.parse(dataStr);
    console.log("订单数据:", parsed);

    if (
      parsed &&
      parsed.direct === true &&
      Array.isArray(parsed.items) &&
      parsed.items.length > 0
    ) {
      isDirectBuy.value = true;
      info.value = parsed;
      handleJSDirect(parsed.items);
    } else if (Array.isArray(parsed) && parsed.length > 0) {
      isDirectBuy.value = false;
      info.value = parsed;
      handleJS(parsed);
    } else {
      $toast.error("订单数据无效", { position: "top" });
      router.push("/shopping");
    }
  } catch (error) {
    console.error("解析订单数据失败:", error);
    $toast.error("订单数据格式错误", { position: "top" });
    router.push("/shopping");
  }
});

/** 从购物车结算 */
const handleJS = (cartItems) => {
  JSCart({ items: [...cartItems] })
    .then((res) => {
      if (res && res.code === 200 && res.data) {
        orderInfo.value = res.data;
      } else {
        $toast.error(res?.message || "获取订单信息失败", { position: "top" });
        router.push("/shopping");
      }
    })
    .catch((error) => {
      console.error("获取订单信息失败:", error);
      $toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "获取订单信息失败，请稍后重试",
        {
          position: "top",
        }
      );
      router.push("/shopping");
    });
};

/** 立即购买结算（不经过购物车） */
const handleJSDirect = (items) => {
  JSCartDirect({ items })
    .then((res) => {
      if (res && res.code === 200 && res.data) {
        orderInfo.value = res.data;
      } else {
        $toast.error(res?.message || "获取订单信息失败", { position: "top" });
        router.push("/shopping");
      }
    })
    .catch((error) => {
      console.error("立即购买结算失败:", error);
      $toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "获取订单信息失败，请稍后重试",
        {
          position: "top",
        }
      );
      router.push("/shopping");
    });
};
// const avtiveType = ref("全部订单");
const jump = (url) => {
  router.push(url);
};
// const handleType = (val) => {
//   avtiveType.value = val;
// };
const modal = ref(false); //弹窗控制
const openModal = () => {
  modal.value = true;
};
onBeforeMount(() => {
  getAddressListData();
});

const addressList = ref();
const getAddressListData = () => {
  getAddressList()
    .then((res) => {
      if (res && res.code == 200) {
        addressList.value = res.data || [];
        const defaultAddress = res.data?.filter((item) => item.isDefault)[0];
        if (defaultAddress) {
          selectAddress.value = defaultAddress;
          showAddress.value = defaultAddress;
        }
      }
    })
    .catch((error) => {
      console.error("获取地址列表失败:", error);
      // 如果地址服务不存在，使用空数组，不影响订单确认流程
      addressList.value = [];
    });
};

const selectAddress = ref({
  id: "",
  name: "",
  phone: "",
  areaName: "",
  detailAddress: "",
  isDefault: false,
});
const showAddress = ref({
  id: "",
  name: "",
  phone: "",
  areaName: "",
  detailAddress: "",
  isDefault: false,
});

const getSelectAddress = (e) => {
  selectAddress.value = e;
};

const handleSureAddress = () => {
  showAddress.value = selectAddress.value;
  modal.value = false;
};
const account = () => {
  // 验证地址（如果地址服务不可用，允许继续）
  if (!selectAddress.value || !selectAddress.value.id) {
    // 如果地址服务不可用，使用临时地址信息
    if (!addressList.value || addressList.value.length === 0) {
      $toast.warning("地址服务暂不可用，将使用默认地址", {
        position: "top",
      });
      // 设置临时默认地址
      selectAddress.value = {
        id: 0,
        name: "待填写",
        phone: "待填写",
        areaName: "待填写",
        detailAddress: "待填写",
        isDefault: false,
      };
    } else {
      $toast.error("请选择收货地址", {
        position: "top",
      });
      return;
    }
  }

  // 验证订单项
  if (isDirectBuy.value) {
    if (!info.value?.items?.length) {
      $toast.error("订单数据无效", { position: "top" });
      return;
    }
  } else {
    if (!info.value || !Array.isArray(info.value) || info.value.length === 0) {
      $toast.error("订单数据无效", { position: "top" });
      return;
    }
  }

  const addressId =
    selectAddress.value.id && selectAddress.value.id !== 0
      ? selectAddress.value.id
      : 1; // 使用默认地址ID 1

  const payload = {
    addressId,
    items: isDirectBuy.value ? [...info.value.items] : [...info.value],
  };
  if (
    selectAddress.value &&
    selectAddress.value.id &&
    selectAddress.value.id !== 0
  ) {
    payload.receiverName = selectAddress.value.name || "";
    payload.receiverPhone = selectAddress.value.phone || "";
    payload.receiverAddress = selectAddress.value.areaName || "";
    payload.receiverDetailAddress = selectAddress.value.detailAddress || "";
  }

  const createApi = isDirectBuy.value ? createOrderDirect : createOrder;
  createApi(payload)
    .then((res) => {
      if (res && res.code === 200 && res.data) {
        createdOrderId.value = res.data;
        $toast.success("订单已创建，请选择支付方式", { position: "top" });
      } else {
        $toast.error(res?.message || "创建订单失败", {
          position: "top",
        });
      }
    })
    .catch((error) => {
      console.error("创建订单失败:", error);
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "创建订单失败，请稍后重试";
      $toast.error(errorMsg, {
        position: "top",
      });
    });
};

/** 结算后自动模拟支付并跳转订单详情（测试用） */
const accountThenMockPay = () => {
  if (isDirectBuy.value && !info.value?.items?.length) {
    $toast.error("订单数据无效", { position: "top" });
    return;
  }
  if (
    !isDirectBuy.value &&
    (!info.value || !Array.isArray(info.value) || !info.value.length)
  ) {
    $toast.error("订单数据无效", { position: "top" });
    return;
  }
  if (
    !selectAddress.value?.id &&
    (!addressList.value || !addressList.value.length)
  ) {
    $toast.error("请选择收货地址", { position: "top" });
    return;
  }
  const addressId =
    selectAddress.value?.id && selectAddress.value.id !== 0
      ? selectAddress.value.id
      : 1;
  const payload = {
    addressId,
    items: isDirectBuy.value ? [...info.value.items] : [...info.value],
  };
  if (selectAddress.value?.id && selectAddress.value.id !== 0) {
    payload.receiverName = selectAddress.value.name || "";
    payload.receiverPhone = selectAddress.value.phone || "";
    payload.receiverAddress = selectAddress.value.areaName || "";
    payload.receiverDetailAddress = selectAddress.value.detailAddress || "";
  }
  const createApi = isDirectBuy.value ? createOrderDirect : createOrder;
  createApi(payload)
    .then((res) => {
      if (res && res.code === 200 && res.data) {
        const orderId = res.data;
        mockPaymentSuccess({ orderId })
          .then((r) => {
            if (r && r.code === 200) {
              $toast.success("已创建订单并模拟支付成功", { position: "top" });
              router.push(`/myOrder/detail/${orderId}`);
            } else {
              createdOrderId.value = orderId;
              $toast.error(r?.message || "模拟支付失败，请在此页点击模拟支付", {
                position: "top",
              });
            }
          })
          .catch(() => {
            createdOrderId.value = orderId;
            $toast.warning(
              "模拟支付请求失败，请点击下方「模拟支付（测试）」重试",
              {
                position: "top",
              }
            );
          });
      } else {
        $toast.error(res?.message || "创建订单失败", { position: "top" });
      }
    })
    .catch((error) => {
      $toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "创建订单失败，请稍后重试",
        { position: "top" }
      );
    });
};

const handleMockPay = () => {
  if (!createdOrderId.value) return;
  mockPaymentSuccess({ orderId: createdOrderId.value })
    .then((res) => {
      if (res && res.code === 200) {
        $toast.success("模拟支付成功，订单已变为待发货", { position: "top" });
        router.push(`/myOrder/detail/${createdOrderId.value}`);
      } else {
        $toast.error(res?.message || "模拟支付失败", { position: "top" });
      }
    })
    .catch((err) => {
      $toast.error(
        err?.response?.data?.message || err?.message || "模拟支付失败",
        {
          position: "top",
        }
      );
    });
};

const payFor = (orderId) => {
  if (!orderId) {
    $toast.error("订单ID无效", {
      position: "top",
    });
    return;
  }

  pay({
    channelCode: firstRealChannelCode.value,
    id: orderId,
    returnUrl: `${window.location.origin}`,
  })
    .then((res) => {
      if (res && res.code === 200 && res.data && res.data.displayContent) {
        window.open(res.data.displayContent, "_blank");
        $toast.success("正在跳转到支付页面", {
          position: "top",
        });
      } else {
        $toast.error(res?.message || "获取支付信息失败", {
          position: "top",
        });
      }
    })
    .catch((error) => {
      console.error("支付失败:", error);
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "支付失败，请稍后重试";
      $toast.error(errorMsg, {
        position: "top",
      });
    });
};
// 动态计算商品总数
/** 价格格式化为两位小数，避免显示 ￥0.1.00 */
const formatPrice = (val) => {
  const n = Number(val);
  return Number.isFinite(n) ? n.toFixed(2) : "0.00";
};

const selectedAllNum = computed(() => {
  return orderInfo.value.itemList
    .map((item) => item.goodsNumber)
    .reduce((acc, currentValue) => acc + currentValue, 0);
});

/** 是否有非模拟的支付方式（支付宝/微信/数币等） */
const hasRealChannel = computed(() =>
  enabledChannels.value.some((c) => c.channelCode && c.channelCode !== "MOCK")
);
/** 是否开启模拟支付 */
const hasMockChannel = computed(() =>
  enabledChannels.value.some((c) => c.channelCode === "MOCK")
);
/** 第一个真实支付渠道的 code，用于「去支付」 */
const firstRealChannelCode = computed(() => {
  const ch = enabledChannels.value.find(
    (c) => c.channelCode && c.channelCode !== "MOCK"
  );
  return ch ? ch.channelCode : "ALI_PC";
});
</script>
<style scoped lang="scss">
.page {
  background-color: transparent;
  position: relative;
  padding: 86px 240px 0 240px;
  .content {
    width: 1200px;
    margin: 0 auto;
    .title {
      display: flex;
      padding-top: 76px;
      .name {
        width: 346x;
        height: 51px;
        font-weight: bold;
        font-size: 40px;
        color: var(--ux-text-primary);
        line-height: 46.998px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-bottom: 34px;
      }
    }
    .base_info {
      // width: 1200px; // height: 922px;
      border-radius: 30px 30px 0 0;
      background: var(--ux-glass-bg);
      padding: 0 35px 20px 35px;
      border-bottom: 0.5px solid var(--ux-glass-border);
      .info_title {
        font-family: Source Han Sans;
        font-size: 24px;
        font-weight: 350;
        color: var(--ux-text-primary);
        padding: 21px 0 21px 0px;
      }
    }
    .accounts {
      width: 1200px;
      height: 94px;
      background: var(--ux-glass-bg);
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      border-radius: 0 0 30px 30px;
      .accounts1 {
        margin-left: 637px;
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: 350;
      }
      .accounts2 {
        font-family: Source Han Sans;
        font-size: 24px;
        font-weight: bold;
        color: #ff0000;
        margin: 0 22px;
      }
      .accounts3 {
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: 350;
      }
      .accounts4 {
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: 350;
        margin-left: 40px;
        margin-right: 5px;
      }
      .accounts5 {
        font-family: Source Han Sans;
        font-size: 24px;
        font-weight: bold;
        color: #ff0000;
      }
      .pay-actions {
        display: flex;
        align-items: center;
        margin-left: 50px;
        gap: 12px;
      }
      .pay-actions .submit {
        margin-left: 0;
      }
      .pay-actions .pay-actions-tip {
        font-size: 14px;
        color: #909399;
      }
      .submit {
        width: 152px;
        height: 58px;
        line-height: 58px;
        text-align: center;
        border-radius: 50px;
        opacity: 1;
        background: var(--ux-card-bg);
        font-family: Source Han Sans;
        font-size: 24px;
        font-weight: 350;
        margin-left: 50px;
        cursor: pointer;
      }
      .submit.mock-pay {
        background: var(--ux-img-placeholder);
        color: #666;
      }
      .submit.submit-mock {
        margin-left: 12px;
        background: rgba(0, 212, 255, 0.12);
        color: var(--ux-accent, #00d4ff);
        border: 0.5px solid rgba(0, 212, 255, 0.35);
      }
    }
  }
  .back {
    position: absolute;
    right: 28px;
    top: 28px;
    width: 48.006px;
    &:hover {
      cursor: pointer;
    }
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(6, 10, 20, 0.55);
    backdrop-filter: saturate(140%) blur(8px);
    -webkit-backdrop-filter: saturate(140%) blur(8px);
    opacity: 1;
    width: 100%;
    height: 100%;
  }
}

.address {
  border-radius: 30px;
  margin-bottom: 21px;
  color: var(--ux-text-primary);
  padding: 10px;
  position: relative;
  background: var(--ux-glass-bg);
  padding: 30px;
  .address_title {
    font-family: Source Han Sans;
    font-size: 24px;
    font-weight: 350;
    margin-bottom: 15px;
  }
  .phone {
    font-family: Source Han Sans;
    font-size: 24px;
    font-weight: 350;
    opacity: 0.5;
    margin-bottom: 7px;
  }
  .address_detail {
    font-family: Source Han Sans;
    font-size: 24px;
    font-weight: 350;
    opacity: 0.5;
  }
  .edit {
    position: absolute;
    bottom: 20px;
    right: 35px;
    height: 50px;
    border-radius: 10px;
    font-size: 20px;
  }
}

.address_modal {
  width: 700px;
  height: 700px;
  padding: 20px;
  .address {
    height: 75%;
    overflow-y: scroll;
    margin: 50px 20px 0 20px;
    .address_list {
      margin-bottom: 20px;
      position: relative;
      .address_title {
        color: var(--ux-text-primary);
        opacity: 0.5;
        font-family: Source Han Sans;
        font-size: 16px;
        font-weight: normal;
      }
      .address_detail {
        width: 95%;
        height: 88px;
        border-radius: 10px;
        background: var(--ux-glass-bg-subtle);
        font-family: Source Han Sans;
        font-size: 16px;
        padding: 16px 0 0 16px;
        position: relative;
        color: var(--ux-text-primary);
        cursor: pointer;
        p {
          opacity: 0.5;
        }
        .name {
          display: flex;
          margin-bottom: 15px;
          .item {
            margin-right: 20px;
          }
        }
        .b_list {
          position: absolute;
          bottom: 10px;
          right: 10px;
          display: flex;
          cursor: pointer;
          color: var(--ux-text-primary);
          .b1 {
            margin-right: 10px;
          }
        }
      }
    }
  }
  .sure_address {
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translateX(-50%);
    width: 88px;
    height: 50px;
    border-radius: 10px;
    font-family: Source Han Sans;
    font-size: 20px;
    font-weight: normal;
    background: var(--ux-glass-bg);
    text-align: center;
    line-height: 50px;
    cursor: pointer;
  }
  .add_address {
    position: absolute;
    right: 40px;
    top: 20px;
    width: 60px;
    height: 40px;
    border-radius: 10px;
    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: normal;
    color: blue;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
  .add_address_modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -150%);
    width: 700px;
    height: 500px;
    z-index: 10;
    background-color: var(--ux-card-bg);
    transition: all 0.5s ease-out;
    padding: 50px 30px 30px 30px;
    .add_form {
      height: 100%;
      position: relative;
      .btn_list {
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        .item {
          width: 88px;
          height: 50px;
          border-radius: 10px;
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: normal;
          background: var(--ux-glass-bg);
          text-align: center;
          line-height: 50px;
          cursor: pointer;
          margin-right: 20px;
        }
      }
    }
  }
  .address_active {
    transform: translate(-50%, -50%);
  }
}
.info_list {
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  margin-bottom: 10px;
  background: var(--ux-card-bg);
  padding: 25px 35px;
  .left_title {
    color: var(--ux-text-primary);
    font-family: Source Han Sans;
    font-size: 20px;
    font-weight: 350;
    margin-bottom: 15px;
  }
  .left {
    display: flex;
    .left_content_list {
      display: flex;
      .pic {
        width: 142px;
        height: 142px;
        padding: 20px;
        background-color: var(--ux-glass-bg-subtle);
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text_list {
        margin-left: 7px;
        .price {
          font-family: Source Han Sans;
          font-size: 20px;
          font-weight: 700;
          .z {
            font-weight: 700;
            font-size: 18px;
          }
        }
        .text_title {
          font-family: Source Han Sans;
          font-size: 14px;
          font-weight: 350;
          color: #3d3d3d;
          opacity: 0.5;
          margin-top: 13px;
          width: 240px;
        }
        .text_count {
          font-family: Source Han Sans;
          font-size: 14px;
          font-weight: 350;
          color: #3d3d3d;
          opacity: 0.5;
          margin-top: 28px;
        }
        .count {
          margin-right: 28px;
          display: flex;
          margin-top: 21.994px;
          .left1 {
            width: 40px;
            height: 40px;
            background: var(--ux-surface-muted);
            border-radius: 42px 42px 42px 42px;
            font-weight: bold;
            font-size: 20.006px;
            color: var(--ux-text-primary);
            line-height: 39.998px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            &:hover {
              cursor: pointer;
            }
          }
          .mid {
            width: 71px;
            height: 40px;
            background: var(--ux-card-bg);
            border-radius: 5px 5px 5px 5px;
            border: 1px solid var(--ux-surface-muted);
            color: var(--ux-text-primary);
            line-height: 39.998px;
            text-align: center;
            margin: 0 9.8px;
            font-weight: bold;
          }
          .right1 {
            width: 39.998px;
            height: 39.998px;
            background: var(--ux-surface-muted);
            border-radius: 42px 42px 42px 42px;
            font-weight: bold;
            font-size: 20.006px;
            color: var(--ux-text-primary);
            line-height: 39.998px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .mid {
    margin-left: 140px;
    .mid_title {
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: 350;
      color: var(--ux-text-primary);
      margin-bottom: 8px;
    }
    .mid_content {
      display: flex;
      margin-bottom: 8px;
      .item {
        font-family: Source Han Sans;
        font-size: 20px;
        font-weight: 350;
        color: var(--ux-text-primary);
        opacity: 0.5;
      }
    }
    .mid_item {
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: 350;
      color: var(--ux-text-primary);
      opacity: 0.5;
      margin-bottom: 8px;
    }
  }
  .right {
    margin-left: 70px;
    .right_title {
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: 350;
      color: var(--ux-text-primary);
      margin-bottom: 8px;
    }
    .right_item {
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: 350;
      color: var(--ux-text-primary);
      opacity: 0.5;
      margin-bottom: 8px;
    }
  }
}
.price_detail {
  border-radius: 20px;
  display: flex;
  align-items: center;
  .detail_list {
    .price_detail_title {
      font-family: Source Han Sans;
      font-size: 20px;
      font-weight: 350;
      color: var(--ux-text-primary);
      margin-bottom: 7px;
    }
    .price_detail_price {
      font-family: Source Han Sans;
      font-size: 18px;
      font-weight: 350;
      color: var(--ux-text-primary);
      opacity: 0.5;
    }
  }
  .way_list {
    display: flex;
    margin-left: 160px;
    .way_item {
      position: relative;
      width: 94px;
      margin-right: 64px;
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      img {
        width: 100%;
      }
      .item_title {
        font-size: 13px;
      }
      &.way_item_empty {
        color: #909399;
        cursor: default;
      }
    }
  }
}
</style>
